import { DataServer } from "../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toggleLoading } from "../LoadingSlice";
import { AnyIfEmpty } from "react-redux";

interface DimensionPdfFileState {
  DimentionPdfFile: {
    load: boolean;
    data: [];
  };
}

export const DimentionPdfFileSlice = createSlice({
  name: "DimentionPdfFile",
  initialState: {
    DimentionPdfFile: {
      load: false,
      data: [],
    },
  } as DimensionPdfFileState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchDimentionPdfFile.pending, (state: DimensionPdfFileState) => {
        state.DimentionPdfFile.load = true;
      })
      .addCase(fetchDimentionPdfFile.fulfilled, (state: DimensionPdfFileState, action: any) => {
        state.DimentionPdfFile.data = action.payload;
        state.DimentionPdfFile.load = false;
      })
      .addCase(fetchDimentionPdfFile.rejected, (state: DimensionPdfFileState) => {
        state.DimentionPdfFile.load = false;
      });
  },
});

export default DimentionPdfFileSlice.reducer;

export const fetchDimentionPdfFile = createAsyncThunk(
  "DimentionPdfFile/fetchDimentionPdfFile",
  async (param: { apiParam : {warehouse_id: any, project_pin: any} }, thunkAPI) => {
    try {
      thunkAPI.dispatch(toggleLoading());
      const { data } = await DataServer.post("api/getDimensionPdfFile", {
        warehouse_id: param.apiParam.warehouse_id,
        project_pin: param.apiParam.project_pin
      });
      thunkAPI.dispatch(toggleLoading());
      return data.data;
    } catch (error) {
      thunkAPI.dispatch(toggleLoading());
    }
  }
);